import { render, staticRenderFns } from "./ServiceSpotMessagesSendPage.vue?vue&type=template&id=76c7ff7a"
import script from "./ServiceSpotMessagesSendPage.vue?vue&type=script&lang=js"
export * from "./ServiceSpotMessagesSendPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports